module.exports = __webpack_public_path__ + "73f70d1e0c978898515b1fd1e67c9e43.svg";